import React from 'react'
import { Drawer, Space, Button, Image, Row, Col } from 'antd';
import { qtyupdate, cartCouponSelector, deleteCartItem } from '../../api/cartSlice'
import {useDispatch, useSelector} from 'react-redux'
import styled from 'styled-components'
import { MdCardGiftcard, MdDelete } from "react-icons/md";
import {showModal, loginSelector } from '../../api/authSlice'
import {viewCartshowModal, modalSelector} from '../../api/modalSlice'
import emptycartImg from '../../images/empty-cart.jpg'
import {Link, Redirect} from 'react-router-dom'
// import {viewCartshowModal, modalSelector} from '../../api/modalSlice'
import Loader from '../../shared/loader'

export default function CartView(props) {


  const dispatch = useDispatch()

const cart = useSelector(cartCouponSelector)
const {isAuthenticate, logpopUp } = useSelector(loginSelector)
const { visibleViewcart} = useSelector(modalSelector)


const increment = (id) =>{

  let data = {id, incr:'incr'}

  dispatch(qtyupdate(data))
  

}

const decrement = (id) =>{

  let data = {id, decr:'decr'}
 
  dispatch(qtyupdate(data))



}



const handleClick = () =>{

  dispatch(viewCartshowModal(false))
 
  logpopUp? dispatch(viewCartshowModal(false))

  : dispatch(showModal(true))



}


    return (
        <div>
          <div className='mt-8 text-center py-1 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl' style={{minHeight:'67vh' }}>
              {/* <Drawer

          width="75%"
          title="View Cart"
          placement="right"
          closable={false}
          onClose={()=>dispatch(viewCartshowModal(false))}
          visible={visibleViewcart}
          key="right"
        > */}
    {cart.cartCoupons.length > 0 ?  <>
          <div className='' style={{backgroundColor:"#9a4c9d"}} >
            <div className="px-2 flex text-white items-center" >

              <div  className=" w-[40%]"><h6 className="text-white py-2 mb-0 text-center">Voucher</h6></div>
              <div  className=" w-[20%] "><h6 className="text-white py-2 mb-0 text-center">Price</h6></div>
              <div  className="w-[40%] "><h6 className="text-white py-2 mb-0 text-center">Quantity</h6></div>
              
            </div>
          </div>
          {
              cart.cartCoupons.map((item, i)=>{

                return  <div key={i} className=" flex text-white text-center  shadow-sm my-3 py-1">
                     <div className=" w-[40%] flex text-center">
                     {/* <MdCardGiftcard className="bg-black text-[2.5rem] p-[5px] text-orange-500"/>   */}
                      {/* {item.type === 'coupon' ? <MdCardGiftcard className="bg-dark voucher"/>
                       : 
                        <Image    
                       preview={false}               
                       style={{margin:'0px',height:"45px", width:"100%", display:'block'}}
                       src={ item?.image}
                       placeholder='image'              
                       /> 
                      }&nbsp; */}
                      
                       <small className="text-[#262626] my-auto pl-1 px-auto " style={{fontSize:'0.75rem' , textTransform:"capitalize"}}><b>{item.name}</b></small>
                       </div>
                    

        
                     <div className="w-[10%]"><h6>&#x20B9; {item.value}</h6></div>
                     {/* <div className="w-[40%] flex justify-end ml-10 md:ml-0">
                    <div className='space-x-0 mr-0 pr-0 w-auto md:mr-10 '>
                     <Button disabled={(item.qty === 1)? true : false} type='default' className='bg-[#9a4c9d]' onClick={()=>decrement(item._id)}>-</Button>
                     <Button>{item.qty}</Button>
                     <Button type='primary'  onClick={()=>increment(item._id)}>+</Button>
                     </div>
                     <div className=" ml-0 pl-0">
                       <MdDelete onClick={()=>dispatch(deleteCartItem(item._id))} className="text-[2rem] text-red-400 cursor-pointer block m-auto "/>
                       </div>
                   </div> */}
                   <div className="w-full md:w-[40%] flex justify-end md:ml-0 ml-2">
  <div className="flex items-center space-x-2 md:space-x-4 mr-0 md:mr-10">
    <Button 
      disabled={item.qty === 1} 
      type="default" 
      className="bg-[#9a4c9d]" 
      onClick={() => decrement(item._id)}
    >
      -
    </Button>
    <Button>{item.qty}</Button>
    <Button 
      type="primary"  
      onClick={() => increment(item._id)}
    >
      +
    </Button>
  </div>
  <div className="ml-2 md:ml-0">
    <MdDelete 
      onClick={() => dispatch(deleteCartItem(item._id))} 
      className="text-[1.5rem] md:text-[2rem] text-red-400 cursor-pointer block m-auto"
    />
  </div>
</div>

                 
                </div>
              })
          }
       
       <div className="px-[8px] py-[16px] bg-[#f5f5f5] mt-5">


       <div className="flex mx-10 text-center">

        <div className="w-[70%] "><h6 className='text-[#9a4c9d]'>{cart.cartCoupons.length}&nbsp; Quantity</h6></div>

        <div className="w-[30%]"><h6 className='text-[#9a4c9d]' >&#x20B9; {cart.total}&nbsp; </h6></div>


       </div>


       </div>
       {isAuthenticate?
        <Link  className="btn btn-warning float-right my-6" to="/checkout">
          Proceed to CheckOut</Link> :
         <Button onClick={handleClick} className="btn  float-right my-3 mx-2 shadow-md" 
         style={{color:'#9a4c9d', backgroundColor:'#9a4c9d29', border:'1px solid #9a4c9d29', fontWeight:'500'}}>Login</Button>}
      

       </> : <div className=''>
        <img className='mt-16 md:ml-[25%] ' src={emptycartImg} alt="img" />
        </div>
          }
        {/* </Drawer>  */}
        </div>
        </div>
    )
}

const CartWrap = styled.div`

.voucher{

  font-size:2.5rem;
  padding:0.3rem;
  color:orange;
}

.close {

  font-size:2rem;
  color:red;
  /* background-color:red; */
  cursor: pointer;
  display:block;
  margin:auto;
}

.Amount{
padding:0.5rem 1rem;

  background-color:#f5f5f5;

  h6{

    color:#9a4c9d !important;
    margin:0;
  }
 
}



`